<template>
  <div v-if="isVisible" class="onboarding-overlay">
    <div class="onboarding-popup">
      <!-- Close button -->
      <button @click="closeOnboarding" class="close-btn">
        <i class="fa-solid fa-x"></i>
      </button>

      <!-- Page 1: Welcome -->
      <div v-if="currentPage === 1" class="onboarding-page page-welcome">
        <div class="page-content">
          <div class="emoji-container">
            <img :src="require('@/assets/img/roboexpression/Waving.png')" alt="Robo" class="welcome-emoji" />
          </div>
          <h2 class="page-title">به روبو خوش اومدی!</h2>
          <p class="page-subtitle">اینجا می‌تونی هر چیزی با هوش مصنوعی بسازی</p>
          <p class="page-subtitle">بگو از کجا شروع کنیم؟</p>
          <div class="feature-buttons">
            <button @click="selectFeature('study')" class="feature-btn study-btn">
              <i class="fa-solid fa-book"></i>
              <span>کمک درسی و تکالیف</span>
            </button>
            <button @click="selectFeature('image')" class="feature-btn image-btn">
              <i class="fa-solid fa-image"></i>
              <span>ساخت تصویر</span>
            </button>
            <button @click="selectFeature('edit')" class="feature-btn edit-btn">
              <i class="fa-solid fa-paintbrush"></i>
              <span>ادیت تصویر</span>
            </button>
            <button @click="selectFeature('video')" class="feature-btn video-btn">
              <i class="fa-solid fa-video"></i>
              <span>ساخت ویدیو</span>
            </button>
            <button @click="selectFeature('work')" class="feature-btn work-btn">
              <i class="fa-solid fa-briefcase"></i>
              <span>کار و تولید محتوا</span>
            </button>
          </div>
        </div>
      </div>

      <!-- Page 2: Quick Start -->
      <div v-if="currentPage === 2" class="onboarding-page page-quickstart">
        <div class="page-content">
          <div class="emoji-container">
            <img :src="getQuickStartEmoji()" alt="Quick Start" class="quickstart-emoji" />
          </div>
          <h2 class="page-title">{{ getQuickStartTitle() }}</h2>
          <p class="page-subtitle">{{ getQuickStartDescription() }}</p>
          
          <div class="action-container">
            <button @click="performQuickAction()" class="action-btn">
              {{ getQuickStartButtonText() }}
            </button>
          </div>
          
          <div class="hint-container">
            <p class="hint-text">{{ getQuickStartHint() }}</p>
          </div>
        </div>
      </div>

      <!-- Page 3: Reward -->
      <div v-if="currentPage === 3" class="onboarding-page page-reward">
        <div class="page-content">
          <div class="emoji-container">
            <img :src="require('@/assets/img/roboexpression/Celebrating.png')" alt="Reward" class="reward-emoji" />
          </div>
          <h2 class="page-title">🎉 تبریک! ۱۰ کوکی جایزه گرفتی</h2>
          <p class="page-subtitle">الان سطح ۱ هستی. بعد از ۳ روز استفاده، به سطح ۲ می‌رسی و پاداش بیشتری می‌گیری.</p>
          
          <div class="reward-animation">
            <div class="cookie-animation">🍪</div>
            <div class="level-indicator">
              <span class="current-level">سطح ۱</span>
              <div class="progress-bar">
                <div class="progress-fill" :style="{ width: '33%' }"></div>
              </div>
              <span class="next-level">سطح ۲</span>
            </div>
          </div>
          
          <button @click="nextPage()" class="continue-btn">
            ادامه
          </button>
        </div>
      </div>

      <!-- Page 4: Habit Loop -->
      <div v-if="currentPage === 4" class="onboarding-page page-habit">
        <div class="page-content">
          <div class="emoji-container">
            <img :src="require('@/assets/img/roboexpression/Hungry.png')" alt="Habit" class="habit-emoji" />
          </div>
          <h2 class="page-title">موفق شدی!</h2>
          <p class="page-subtitle">هر روز ۱۰ کوکی رایگان دریافت می‌کنی. فردا برگرد تا جایزه‌ات از دست نره.</p>
          
          <div class="habit-info">
            <div class="daily-reward">
              <i class="fa-solid fa-calendar-day"></i>
              <span>۱۰ کوکی روزانه</span>
            </div>
            <div class="unlimited-option">
              <p class="unlimited-text">می‌خوای دسترسی نامحدود داشته باشی؟</p>
              <p class="premium-text"> کوکی🍪 نامحدود با 30 درصد تخفیف</p>
              <p class="premium-text" style="text-decoration: line-through;color: #ff002b">298 هزار تومان</p>
              <p class="premium-text">208 هزار تومان</p>
              <button @click="gotoBuying()" style="background: rgba(255, 255, 255, 0.2);
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-radius: 15px;
  padding: 10px 20px;
  color: white;
  font-size: 15;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);">
            خرید کوکی
          </button>
            </div>
          </div>
          
          <button @click="finishOnboarding()" class="final-btn">
            بزن بریم 🚀
          </button>
        </div>
      </div>

      <!-- Progress dots -->
      <div class="progress-dots">
        <span 
          v-for="page in 4" 
          :key="page" 
          :class="{ active: page === currentPage }"
          class="dot"
        ></span>
      </div>
    </div>
  </div>
</template>

<script>
import router from '@/router';

export default {
  name: 'OnboardingPopup',
  props: {
    isVisible: {
      type: Boolean,
      default: false
    },
    page: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      currentPage: this.page,
      selectedFeature: null,
      quickStartActions: {
        study: {
          title: 'یک متن درسی برایت خلاصه کردیم. امتحان کن!',
          description: 'حالا می‌تونی از روبو برای کمک درسی استفاده کنی',
          buttonText: '📖 خلاصه رو ببین',
          hint: 'روی دکمه کلیک کن تا به بخش گفتگو بری و متن درسی رو خلاصه کنی',
          action: () => this.gotoChatWithSuggestion('یک متن درسی رو برایم خلاصه کن')
        },
        image: {
          title: 'یک پوستر آماده برای استوری اینستاگرام بسازیم؟',
          description: 'حالا می‌تونی تصاویر جذاب بسازی',
          buttonText: '🎨 تصویر رو بساز',
          hint: 'روی دکمه کلیک کن تا به بخش ساخت تصویر بری',
          action: () => this.gotoImageGeneration()
        },
        edit: {
          title: 'عکستو کارتونی بکنیم؟',
          description: 'حالا می‌تونی تصاویرت رو ادیت کنی',
          buttonText: '🎨 تصویر رو بساز',
          hint: 'روی دکمه کلیک کن تا به بخش ادیت تصویر بری',
          action: () => this.gotoEditImage()
        },
        video: {
          title: 'یک ویدیوی کوتاه 8 ثانیه‌ای بسازیم؟',
          description: 'حالا می‌تونی ویدیوهای جذاب بسازی',
          buttonText: '🎬 ویدیو رو بساز',
          hint: 'روی دکمه کلیک کن تا به بخش ساخت ویدیو بری',
          action: () => this.gotoVideoGeneration()
        },
        chat: {
          title: 'با معلم هوش مصنوعی صحبت کن!',
          description: 'حالا می‌تونی با روبو گفتگو کنی',
          buttonText: '💬 شروع گفتگو',
          hint: 'روی دکمه کلیک کن تا به بخش گفتگو بری',
          action: () => this.gotoChat()
        },
        work: {
          title: 'یک متن تبلیغاتی برای محصولت می‌نویسیم.',
          description: 'حالا می‌تونی محتوای کاری تولید کنی',
          buttonText: '🚀 متن رو بساز',
          hint: 'روی دکمه کلیک کن تا به بخش گفتگو بری و متن تبلیغاتی بنویسی',
          action: () => this.gotoChatWithSuggestion('یک متن تبلیغاتی برای محصول من بنویس')
        }
      }
    };
  },
  methods: {
    selectFeature(feature) {
      this.selectedFeature = feature;
      this.nextPage();
    },
    
    nextPage() {
      if(this.currentPage == 3)
      {
        localStorage.removeItem("onBoardingAction")
      }
      if (this.currentPage < 4) {
        this.currentPage++;
      }
    },
    
    getQuickStartEmoji() {
      const emojiMap = {
        study: require('@/assets/img/roboexpression/Phone.png'),
        image: require('@/assets/img/roboexpression/Phone.png'),
        edit: require('@/assets/img/roboexpression/Phone.png'),
        video: require('@/assets/img/roboexpression/Phone.png'),
        chat: require('@/assets/img/roboexpression/Phone.png'),
        work: require('@/assets/img/roboexpression/Phone.png'),
      };
      return emojiMap[this.selectedFeature] || require('@/assets/img/bot.png');
    },
    
    getQuickStartTitle() {
      return this.quickStartActions[this.selectedFeature]?.title || '';
    },
    
    getQuickStartDescription() {
      return this.quickStartActions[this.selectedFeature]?.description || '';
    },
    
    getQuickStartButtonText() {
      return this.quickStartActions[this.selectedFeature]?.buttonText || '';
    },
    
    getQuickStartHint() {
      return this.quickStartActions[this.selectedFeature]?.hint || '';
    },
    
    performQuickAction() {
      const action = this.quickStartActions[this.selectedFeature]?.action;
      if (action) {
        localStorage.setItem("onBoardingAction", "");
        action();
        this.$emit('close');
        //this.nextPage();
      }
    },
    
    gotoChat() {
      localStorage.setItem("conversationId", "");
      router.push("/chat");
    },
    
    gotoChatWithSuggestion(suggestion) {
      localStorage.setItem("character", "chat");
      localStorage.setItem("selectedSuggestion", suggestion);
      localStorage.setItem("conversationId", "");
      router.push("/chat");
    },
    
    gotoImageGeneration() {
      router.push("/imagegeneration");
    },
    
    gotoEditImage() {
      router.push("/editimage");
    },
    
    gotoVideoGeneration() {
      router.push("/videogeneration");
    },
    gotoBuying() {
      localStorage.setItem("onboardingCompleted", "true");
      this.$emit('close');
      router.push("/packages?code=onboardingx30");
    },
    finishOnboarding() {
      localStorage.setItem("onboardingCompleted", "true");
      this.$emit('close');
    },
    
    closeOnboarding() {
      localStorage.setItem("onboardingCompleted", "true");
      this.$emit('close');
    }
  }
};
</script>

<style scoped>
@font-face {
  font-family: IRANSansWeb;
  src: url('../assets/IRANSansWeb.woff2') format("woff2");
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: IRANSansWeb;
  src: url('../assets/IRANSansWebBold.woff2') format("woff2");
  font-weight: bold;
  font-style: normal;
}

.onboarding-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10000;
  backdrop-filter: blur(5px);
}

.onboarding-popup {
  background: linear-gradient(135deg, #6153cc 0%, #8b5cf6 100%);
  border-radius: 20px;
  padding: 30px;
  overflow-y: auto;
  max-width: 90vw;
  scrollbar-width: none;
  max-height: 90vh;
  width: 500px;
  position: relative;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
  animation: slideIn 0.5s ease-out;
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: scale(0.8) translateY(50px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

.close-btn {
  position: absolute;
  top: 15px;
  right: 15px;
  background: rgba(255, 255, 255, 0.2);
  border: none;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  color: white;
  font-size: 18px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}

.close-btn:hover {
  background: rgba(255, 255, 255, 0.3);
  transform: scale(1.1);
}

.onboarding-page {
  text-align: center;
  color: white;
  font-family: IRANSansWeb;
}

.page-content {
}

.emoji-container {
  margin-bottom: 20px;
}

.welcome-emoji,
.quickstart-emoji,
.reward-emoji,
.habit-emoji {
  width: 150px;
  height: 150px;
  object-fit: cover;
  animation: bounce 2s infinite;
}

@keyframes bounce {
  0%, 20%, 50%, 80%, 100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-10px);
  }
  60% {
    transform: translateY(-5px);
  }
}

.page-title {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 15px;
  line-height: 1.4;
}

.page-subtitle {
  font-size: 16px;
  line-height: 1.6;
  opacity: 0.9;
}

.feature-buttons {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 15px;
  margin-bottom: 20px;
}

.feature-btn {
  background: rgba(255, 255, 255, 0.15);
  border: 2px solid rgba(255, 255, 255, 0.2);
  border-radius: 15px;
  padding: 1dvh 10px;
  color: white;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  backdrop-filter: blur(10px);
}

.feature-btn:hover {
  background: rgba(255, 255, 255, 0.25);
  border-color: rgba(255, 255, 255, 0.4);
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
}

.feature-btn i {
  font-size: 20px;
}

.action-container {
  margin-bottom: 20px;
}

.action-btn {
  background: rgba(255, 255, 255, 0.2);
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-radius: 15px;
  padding: 15px 30px;
  color: white;
  font-size: 18px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
}

.action-btn:hover {
  background: rgba(255, 255, 255, 0.3);
  transform: scale(1.05);
}

.hint-container {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 10px;
  padding: 15px;
  margin-top: 20px;
}

.hint-text {
  font-size: 14px;
  opacity: 0.8;
  font-style: italic;
}

.reward-animation {
  margin: 30px 0;
}

.cookie-animation {
  font-size: 60px;
  animation: spin 3s linear infinite;
  margin-bottom: 20px;
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

.level-indicator {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 15px;
  margin-top: 20px;
}

.progress-bar {
  flex: 1;
  height: 8px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 4px;
  overflow: hidden;
}

.progress-fill {
  height: 100%;
  background: linear-gradient(90deg, #ffd700, #ffed4e);
  border-radius: 4px;
  transition: width 0.5s ease;
}

.current-level,
.next-level {
  font-size: 14px;
  font-weight: bold;
}

.habit-info {
}

.daily-reward {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 10px;
  padding: 15px;
  margin-bottom: 20px;
}

.daily-reward i {
  font-size: 20px;
  color: #ffd700;
}

.unlimited-option {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 10px;
  padding: 15px;
}

.unlimited-text {
  font-size: 14px;
  margin-bottom: 10px;
}

.premium-text {
  font-size: 16px;
  font-weight: bold;
  color: #ffd700;
}

.continue-btn,
.final-btn {
  background: rgba(255, 255, 255, 0.2);
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-radius: 15px;
  padding: 15px 30px;
  color: white;
  font-size: 18px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
  margin-top: 20px;
}

.continue-btn:hover,
.final-btn:hover {
  background: rgba(255, 255, 255, 0.3);
  transform: scale(1.05);
}

.progress-dots {
  visibility: hidden;
  display: flex;
  justify-content: center;
  gap: 10px;
  margin-top: 30px;
}

.dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.3);
  transition: all 0.3s ease;
}

.dot.active {
  background: white;
  transform: scale(1.2);
}

@media (max-width: 768px) {
  .onboarding-popup {
    width: 95vw;
    padding: 20px;
  }
  
  .feature-buttons {
    grid-template-columns: 1fr;
  }
  
  .page-title {
    font-size: 20px;
  }
  
  .page-subtitle {
    font-size: 14px;
  }
}
</style>


